import * as z from "zod/v4";

export const saveCustomerPortalBuilderChanges = {
  name: "saveCustomerPortalBuilderChanges" as const,
  input: z.object({
    threadId: z
      .string()
      .describe("The thread ID of the portal builder session"),
    applyChanges: z
      .boolean()
      .default(true)
      .describe(
        "Whether to apply pending updates to the team. Set to false to discard changes.",
      ),
  }),
  output: z.object({ success: z.boolean() }),
};
